import { render, staticRenderFns } from "./admininfo.vue?vue&type=template&id=2e9bcf3a"
import script from "./admininfo.vue?vue&type=script&lang=js"
export * from "./admininfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports